module.exports = __webpack_public_path__ + "static/media/single-left-blue.31fdaeef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Kendra/images/single-left-blue.svg
// module id = 3223
// module chunks = 0